import React from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function BusinessContact({ enableButton, buttonLabel, buttonLink, buttonTarget, desktopImage, mobileImage, heading, body }) {
  const buttonLinkTarget = SelectionFactoryHelper.getFromSelectionFactory(buttonTarget, false)
  // might need window width to re-render mobile img instead of desktop img.
  const windowWidth = useWindowWidth()

  return (
    <div className="business-contact">
      <div className="business-contact-container">
        <div className="w--wider">
          <div className="grid vertical-center">
            <div className="grid-item col--12 col-sm--6 textside">
              <div className="text-area">
                <div data-epi-property="Heading" className="rich-text">
                  {ReactHtmlParser(heading)}
                </div>
                <p>{body}</p>
                {/* we call it button, but it is a link...*/}
                <a data-epi-property="ButtonLabel" href={buttonLink} target={buttonLinkTarget} className="button button--medium button--general">
                  {buttonLabel}
                </a>
              </div>
            </div>
            <div className="grid-item col--12 col-sm--6 imgside">
              <div className="image-area">
                <img data-epi-property="DesktopImage" src={windowWidth >= 768 ? desktopImage : mobileImage}></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
